import React, { Suspense, lazy } from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import { Loader } from './cmps/loader'
import { Toast } from './cmps/toast'

// Code-split every route so each screen ships its own JS chunk. Opening the board no longer
// downloads the code for Landing / Modules (and vice-versa) — and every future module
// (Dashboard, Attribution, Todos, TicketTailor) becomes its own lazy chunk that costs the
// board ZERO. Adding modules stops making the whole app heavier.
const BoardDetails = lazy(() => import('./pages/board-details').then(m => ({ default: m.BoardDetails })))
const ModulePage = lazy(() => import('./pages/module-page').then(m => ({ default: m.ModulePage })))
const LandingPage = lazy(() => import('./pages/landing-page'))

function AppRoutes() {
    return (
        <Routes>
            <Route element={<LandingPage />} path='/' />
            <Route element={<BoardDetails />} path='/board/:boardId/' />
            <Route element={<BoardDetails />} path='/board/:boardId/:groupId/:taskId' />
            <Route element={<BoardDetails />} path='/board/:boardId/:activityLog' />
            <Route element={<ModulePage />} path='/m/:moduleId' />
            {/* The old /auth login & signup pages are gone — everything goes through the landing page. */}
            <Route element={<Navigate to="/" replace />} path='/auth/login' />
            <Route element={<Navigate to="/" replace />} path='/auth/signup' />
            <Route element={<Navigate to="/" replace />} path='*' />
        </Routes>
    )
}

export function RootCmp () {
    return (
        <div>
            <main>
                <Suspense fallback={<Loader />}>
                    <AppRoutes />
                </Suspense>
            </main>
            <Toast />
        </div>
    )
}
